import {
  initializeApp
} from 'firebase/app';

if (!process.env.FIREBASE_CONFIGURATION) {
  throw new Error('FIREBASE_CONFIGURATION env value missing');
}
const firebaseconfig = JSON.parse(process.env.FIREBASE_CONFIGURATION);

const app = initializeApp(firebaseconfig);
const emulator = process.env.FIRESTORE_EMULATOR_HOST ?? null;
let init = async () => {
  if (emulator) {
    // https://firebase.google.com/docs/emulator-suite/connect_firestore#android_ios_and_web_sdks
    const {
      getFirestore, connectFirestoreEmulator
    } = await import('firebase/firestore');

    // FIXME: have not be able to get parcel fs.readFileSync to work; would rather
    //        import the json to get port (also for the firebaseconfig above)
    //        https://v2.parceljs.org/features/node-emulation/#%F0%9F%93%84-inlining-fs.readfilesync
    //
    const port = parseInt(emulator.split(':')[1]);
    connectFirestoreEmulator(
      getFirestore(), 'localhost', port
    );
  }
  init = async () => {};
};

export default async function getFirebase () {
  await init();
  return app;
};